module.exports = __webpack_public_path__ + "img/4image-4.70b85158.png";